import React from 'react';

const Research = () => {
    return (
        <>
            <h2>Publications and Abstracts</h2>
            <ul>
                <li><a href="https://doi.org/10.1016/j.jocd.2024.101504">Accuracy of volumetric bone mineral density measurement in weight bearing, cone beam computed tomography</a>
                <br />
                with Waungana, T.H., Qiu, K., Tse, J.T., Anderson, D.D., Emery, C.A., Boyd, S.K., Manske, S.L.
                <br />
                <i>Journal of Clinical Densitometry, 2024.</i>
                </li>
                <br />
                <li>Accuracy of BMD measurement in weight bearing, cone-beam CT.
                <br />
                with Tadiwa H. Waungana, Keven Qiu, Justin T. Tse, Donald D. Anderson, Sarah L. Manske.
                <br />
                <i>The American Society for Bone and Mineral Research, 2023. Vancouver, BC, Canada.</i></li>
            </ul>
        </>
    )
}

export default Research;
